import {
  Button, Card, CardContent, Grid, Typography, IconButton, Fade, Modal, Hidden, Backdrop,
} from '@material-ui/core';
import ArrowForwardRoundedIcon from '@material-ui/icons/ArrowForwardRounded';
import CloseIcon from '@material-ui/icons/Close';

const UpdateAddressModal = (props) => {
  const {
    submitAddressFunction, addressState, modalState, modalSetter,
  } = props;

  return (

    <Modal
      aria-labelledby='transition-modal-title'
      aria-describedby='transition-modal-description'
      className='modal-wrapper'
      open={modalState.showModal}
      onBackdropClick={() => modalSetter({ showModal: false })}
      id='address-suggestion-modal'
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={modalState.showModal}>
        <div className='modal-container'>
          <div className='modal-header'>
            <Typography variant='h2'>{'Suggested Address Update'}</Typography>
            <IconButton className='close' aria-label='close' size='medium' onClick={() => modalSetter({ showModal: false })}>
              <CloseIcon />
            </IconButton>
          </div>
          <div className='modal-body'>

            <div className='updateAddressModal'>
              <Typography variant='h4'>
                {'To ensure best shipping options and prompt delivery, we suggest using the following modified version of your address'}
              </Typography>
              <Grid
                container
                spacing={2}
                alignItems='center'
                justify='space-evenly'
              >
                <Grid item xs={12} sm={5}>
                  <Card>
                    <CardContent>
                      <Typography>
                        {addressState.submittedAddress?.address?.addressLine1}
                        {' '}
                        {addressState.submittedAddress?.address?.addressLine2}
                      </Typography>
                      <Typography>
                        {addressState.submittedAddress?.address?.city}
                        {' '}
                        {addressState.submittedAddress?.address?.state}
                        {' '}
                        {addressState.submittedAddress?.address?.zipCode}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={1} style={{ textAlign: 'center' }}>
                  <ArrowForwardRoundedIcon />
                </Grid>

                <Grid item xs={12} sm={5}>
                  <Card>
                    <CardContent>
                      <Typography>
                        {addressState.suggestedAddress?.addressLine1}
                        {' '}
                        {addressState.suggestedAddress?.addressLine2}
                      </Typography>
                      <Typography>
                        {addressState.suggestedAddress?.city}
                        {' '}
                        {addressState.suggestedAddress?.state}
                        {' '}
                        {addressState.suggestedAddress?.zipCode}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={5}>
                  <Button
                    type='button'
                    variant='contained'
                    color='primary'
                    id='use-original-address-button'
                    onClick={() => {
                      submitAddressFunction(addressState.submittedAddress);
                      modalSetter({ showModal: false });
                    }}
                  >
                    {'Use Original Address'}
                  </Button>
                </Grid>

                <Hidden only='xs'>
                  <Grid item xs={1} />
                </Hidden>

                <Grid item xs={12} sm={5}>
                  <Button
                    type='button'
                    variant='contained'
                    color='secondary'
                    id='use-suggested-address-button'
                    onClick={() => {
                      submitAddressFunction({
                        ...addressState.submittedAddress,
                        address: {
                          addressLine1: addressState.suggestedAddress?.addressLine1,
                          addressLine2: addressState.suggestedAddress?.addressLine2,
                          city: addressState.suggestedAddress?.city,
                          state: addressState.suggestedAddress?.state,
                          zipCode: addressState.suggestedAddress?.zipCode,
                        },
                      });
                      modalSetter({ showModal: false });
                    }}
                  >
                    {'Use Suggested Address'}
                  </Button>
                </Grid>

              </Grid>
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

export default UpdateAddressModal;
